import { useRouter } from 'next/router'
import React from 'react'

import HelpCenterDetailArticleFeature from 'app/features/HelpCenter/HelpCenterDetailArticleFeature'
import { useGetHelpCenterArticleDetail } from 'app/services/Query/help-center/help-center.query'
import {
  getArticleCategoriesSlugs,
  hasArticleMultipleCategories
} from 'app/utils/helpers/help-center.helpers'
import { isOfType } from 'app/utils/helpers/type.helpers'

import NextSeo from '~/containers/NextSeo'

import BreadcrumbsBlock from './components/BreadcrumbsBlock'
import HelpCenterContainer from './components/HelpCenterContainer'

const HelpCenterArticleView = () => {
  const { query, isFallback } = useRouter()
  const slug = isOfType.string(query?.slug) ? query?.slug : ''

  const { data: article } = useGetHelpCenterArticleDetail({
    slug,
    options: { enabled: false }
  })

  const articleTitle = article?.title || ''
  const title = `${articleTitle} Help Centre`

  const { categorySlug, subcategorySlug } = getArticleCategoriesSlugs(
    article?.help_center_categories
  )
  const isMultipleCategories = hasArticleMultipleCategories(
    article?.help_center_categories
  )

  return (
    <>
      <NextSeo
        title={title}
        description={title}
        openGraph={{ title: title, description: title }}
        {...(!articleTitle && { canonical: '404' })}
      />

      <BreadcrumbsBlock
        categorySlug={subcategorySlug ?? categorySlug}
        isLoading={isFallback}
        isMultipleCategories={isMultipleCategories}
        articleTitle={articleTitle}
      />

      <HelpCenterContainer
        categorySlug={subcategorySlug ?? categorySlug}
        isLoading={isFallback}
      >
        <HelpCenterDetailArticleFeature
          title={articleTitle}
          body={article?.body}
          isLoading={isFallback}
        />
      </HelpCenterContainer>
    </>
  )
}

export default HelpCenterArticleView
